import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
// import Index from '../views/Index.vue'
// import UserCenter from '../views/UserCenter.vue'
import Login from '../views/Login.vue'
import axios from "../axios";
import store from "../store"

// replace
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace= function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
// push
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		// component: Home,
    component: () => import('@/views/Home.vue'),
		children: [
			{
				path: '/index',
				name: 'Index',
				meta: {
					title: "首页"
				},
				// component: Index
        component: () => import('@/views/Index.vue')
			},
			{
				path: '/userCenter',
				name: 'UserCenter',
				meta: {
					title: "个人中心"
				},
				component: () => import('@/views/UserCenter.vue')
        // component: UserCenter
			}
		]
	},
	{
		path: '/login',
		name: 'Login',
		// component: () => import('@/views/Login.vue')
    component: Login
	},


]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	let hasRoute = store.state.menus.hasRoutes
	let token = localStorage.getItem("token")

	if (to.path === '/login') {
		return next()
	} else if (!token) {
		return next({ path: '/login' })
	} else if (token && !hasRoute) {
		axios.get("/api/sys/menu/nav", {
			headers: {
				token: localStorage.getItem("token")
			}
		}).then(res => {
			// 拿到menuList
			store.commit("setMenuList", res.data.data.nav)

			// 拿到用户权限
			store.commit("setPermList", res.data.data.authoritys)

      	hasRoute = true
      	store.commit("changeRouteStatus", true)

			// 动态绑定路由
			let newRoutes = router.options.routes

			res.data.data.nav.forEach(menu => {
				if (menu.children) {
					menu.children.forEach(e => {

						// 转成路由
						let route = menuToRoute(e)

						// 把路由添加到路由管理中
						if (route) {
							newRoutes[0].children.push(route)
						}
					})
				}
			})

      // 先添加路由，再以 replace 方式进入目标页，避免重复导航
      router.addRoute(newRoutes[0])
      next({ ...to, replace: true })
    }).catch(() => {
      // 拉取菜单失败，回到登录页
      next({ path: '/login' })
    })
    return
	}
	
	next()
})


// 导航转成路由
const menuToRoute = (menu) => {

	if (!menu.component) {
		return null
	}

	let route = {
    path: menu.path,
		name: menu.name,
		meta: {
			icon: menu.icon,
			title: menu.title
		}
	}
	route.component = () => import('@/views/' + menu.component +'.vue')
  // console.log(menu.component)
  // console.log(route)

	return route
}

export default  router



// WEBPACK FOOTER //
// ./src/router/index.js